import BaseExcelService from './BaseExcelService';

class ContractExcelService extends BaseExcelService {
  getBaseUrl() {
    return '~/api/excel/contract';
  }
}

export default new ContractExcelService();
